<template>
    <div :class="theme.dropdownRaw">
        <div v-for="item, index in items" :key="index" :class="getItemClasses(item)" @click="$emit('select', item)">
            <slot name="item" :item="item">
                {{ item }}
            </slot>
        </div>
    </div>
</template>
<script>
    import theme from './dropdown.scss';

    export default {
        name: 'dropdown-raw',
        props: {
            value: [String, Number, Object],
            selected: [String, Number],
            items: [Object, Array],
            onChange: Function,
            theme: {
                type: Object,
                default() {
                    return theme;
                }
            }
        },
        methods: {
            getItemClasses(item) {
                return {
                    [this.theme.dropdownItem]: true,
                    [this.theme.isSelected]: this.value === item,
                };
            },
        }
    }
</script>


// WEBPACK FOOTER //
// DropdownRaw.vue?0495c20c